import { render, staticRenderFns } from "./imageViewer.vue?vue&type=template&id=54dbd841"
import script from "./imageViewer.vue?vue&type=script&lang=js"
export * from "./imageViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports